<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
      </div>
      <div  style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe" style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;padding-bottom: 50px">
            <div class="cell-group Letter_to_parents">
              <div class="title font24 bloder textCenter">告家长书</div>
              <div class="bloder">贵家长：</div>
              <div class="textIndent2 bloder">您好! 为了您的孩子能健康成长，积极地参加学校的各项体育活动，请务必如实填写下表。如果您的孩子有特殊的健康问题，需要我们特殊照顾的，我们将给予关心。请您亲笔填写《学生身体健康状况调查表》，以便学校和班主任能针对学生情况，在安排活动时作适当调整。对因没有如实提供身体健康状况信息而造成安全事故的责任由家长负责。  填写后，由学生交给班主任保存。</div>
              <div class="flexEnd font18 bloder">常熟高新园中等专业学校</div>
              <div class="flexEnd font18 bloder">2021年6月</div>
            </div>

            <div class="title flexCloumnSingleCenter">
              <div class="FS18 bold" style="line-height: 50px;">常熟高新园中等专业学校学生身体健康状况调查表</div>
            </div>
            <div class="table">
              <el-row class="borderR">
                <el-col :span="3" class="cell cell50">系部</el-col>
                <el-col :span="3" class="cell cell50">{{detailInfo.department}}</el-col>
                <el-col :span="3" class="cell cell50">班级</el-col>
                <el-col :span="3" class="cell cell50">{{detailInfo.class}}</el-col>
                <el-col :span="3" class="cell cell50">学生姓名</el-col>
                <el-col :span="3" class="cell cell50">{{baseInfo.stu_name}}</el-col>
                <el-col :span="3" class="cell cell50">性别</el-col>
                <el-col :span="3" class="cell cell50">
                  {{ detailInfo.gender == 1 ? '男' : '' }}
                  {{ detailInfo.gender == 2 ? '女' : '' }}
                  {{ detailInfo.gender == 0 ? '未知' : '' }}
                </el-col>
              </el-row>

              <el-row class="borderR">
                <el-col :span="3" class="cell cell50">电话</el-col>
                <el-col :span="6" class="cell cell50">{{baseInfo.phone}}</el-col>
                <el-col :span="3" class="cell cell50">身份证号码</el-col>
                <el-col :span="12" class="cell cell50">{{detailInfo.idNumber}}</el-col>
              </el-row>

              <el-row class="cell cell50 borderR" style="font-weight: bold;">父母等家庭成员信息</el-row>

              <el-row class="flexStretch borderR">
                <el-col :span="3" class="cell cell50">家长姓名</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.parentName1 }}</el-col>
                <el-col :span="3" class="cell cell50">工作单位</el-col>
                <el-col :span="8" class="cell cell50 flexCenter"
                        style="line-height: unset;word-break: break-all;white-space: break-spaces">{{ detailInfo.workplace1 }}</el-col>
                <el-col :span="3" class="cell cell50">联系电话</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.phone1 }}</el-col>
              </el-row>
              <el-row class="flexStretch borderR">
                <el-col :span="3" class="cell cell50">家长姓名</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.parentName2 }}</el-col>
                <el-col :span="3" class="cell cell50">工作单位</el-col>
                <el-col :span="8" class="cell cell50 flexCenter"
                        style="line-height: unset;word-break: break-all;white-space: break-spaces">{{ detailInfo.workplace2 }}</el-col>
                <el-col :span="3" class="cell cell50">联系电话</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.phone2 }}</el-col>
              </el-row>

              <el-row class="cell cell50 borderR" style="font-weight: bold;">身  体  健  康  状  况（每个空格填“有或无”，不能打√或×）</el-row>
              <el-row class="flexStretch borderR" style="font-weight: bold;">
                <el-col :span="4" class="cell">是否有病症</el-col>
                <el-col :span="4" class="cell">填有或无</el-col>
                <el-col :span="4" class="cell">是否有病症</el-col>
                <el-col :span="4" class="cell">填有或无</el-col>
                <el-col :span="4" class="cell">是否有病症</el-col>
                <el-col :span="4" class="cell">填有或无</el-col>
              </el-row>
              <el-row class="flexStretch borderR" style="font-weight: bold;">
                <el-col :span="4" class="cell">心脏疾病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[0])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">血液病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[1])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">肾炎</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[2])!=-1?'有':'无'}}</el-col>
              </el-row>
              <el-row class="flexStretch borderR" style="font-weight: bold;">
                <el-col :span="4" class="cell">支气管哮喘</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[3])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">癫痫病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[4])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">过敏性疾病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[5])!=-1?'有':'无'}}</el-col>
              </el-row>
              <el-row class="flexStretch borderR" style="font-weight: bold;">
                <el-col :span="4" class="cell">癔病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[6])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">肺结核病</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[7])!=-1?'有':'无'}}</el-col>
                <el-col :span="8" class="cell">其它疾病</el-col>
              </el-row>
              <el-row class="flexStretch borderR" style="font-weight: bold;">
                <el-col :span="4" class="cell">肝炎</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[8])!=-1?'有':'无'}}</el-col>
                <el-col :span="4" class="cell">心理原因</el-col>
                <el-col :span="4" class="cell">{{detailInfo.diseaseChecked.indexOf(diseases[9])!=-1?'有':'无'}}</el-col>
                <el-col :span="8" class="cell">{{otherDiseases}}</el-col>
              </el-row>
              <el-row class="flexStretch borderR">
                <el-col :span="4" class="cell cell50">既往病史简述</el-col>
                <el-col :span="20" class="cell cell50">{{detailInfo.remark1}}</el-col>
              </el-row>
              <el-row class="cell borderR borderB" style="padding: 0 10px;">
                <el-row class="cell50 flexStart">
                  <span>1.能否正常上体育课、进行体育竞赛、跑步、跳舞等剧烈运动（活动）：</span>
                  <span class="uline" >{{detailInfo.attendPEclass==1?'能':'不能'}}</span>
                </el-row>
                <el-row class="flexStretch flexStartUp">
                  <span>2.其他需要说明的问题：</span>
                  <span class="uline flexStart" style="white-space: break-spaces;word-break: break-all;line-height: 30px!important;text-align: left">{{ detailInfo.remark2 }}</span>
                </el-row>
                <el-row class="cell50 flexStart" style="font-weight: 700;">以上信息真实有效</el-row>
                <el-row class="cell50 flexStart" style="font-weight: 700;">
                  <el-col :span="4" class="cell50 flexStart">监护人签名:</el-col>
                  <el-col :span="6" class="cell50 flexCenter">
                    <div class="flexCenter" style="width: 100%;box-sizing:border-box;padding:1px;">
                      <img v-if="detailInfo.signUrl" :src="detailInfo.signUrl" alt="" style="width: 100%;">
                    </div>
                  </el-col>
                </el-row>

              </el-row>
              <div style="padding-left: 10px;padding-top: 5px;font-weight: 700;">注：如今后发现您的孩子出现上述原因的，谢请你们及时告知学校</div>
            </div>
          </div>


        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {

  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
      diseases: ['心脏疾病', '血液病', '肾炎', '支气管哮喘', '癫痫病', '过敏性疾病', '癔病', '肺结核病', '肝炎', '心理原因',],
      otherDiseases:''
    }
  },
  mounted() {
console.log(this.detailInfo.diseaseChecked)
    console.log(this.detailInfo.diseaseChecked.indexOf(this.diseases[2]))
    let arr = []
    if(this.detailInfo.diseaseChecked&&this.detailInfo.diseaseChecked.length>0){
      this.detailInfo.diseaseChecked.map(a=>{
        if(this.diseases.indexOf(a)==-1){
          arr.push(a)
        }
      })
      this.otherDiseases = arr.join(',')
    }

    // diseases: ['心脏疾病', '血液病', '肾炎', '支气管哮喘', '癫痫病', '过敏性疾病', '癔病', '肺结核病', '肝炎', '心理原因',],

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.Letter_to_parents{
  box-sizing: border-box;
  padding-top: 10px!important;
  font-size: 14px;
  .font16{font-size: 16px;}
  .font18{font-size: 18px;}
  .font20{font-size: 20px;}
  .font24{font-size: 24px;}
  .bloder{font-weight: 700}
  .textCenter{text-align: center}
  .textIndent2{text-indent:2em;}
  .xuangua{text-indent:-2em;padding-left:4em}
}

.flexStretch{
  display: flex;justify-content: flex-start;align-items: stretch;
}
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
  .borderR {border-right: 1px solid #333;}
  .borderB {border-bottom: 1px solid #333;}
  .FS18{
    font-size: 18px;
  }
  .bold{
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
  .cell{
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family:"宋体";
  }
  .cell50{
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family:"宋体";
  }
  .cellMore{
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family:"宋体";
  }
}
.uline {
  text-decoration: underline;
}
</style>
